<div class="header-container" [class.left]="position === 'normal'" [class.right]="position === 'inverse'">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="navigation"><i class="nb-menu"></i></a>
  </div>
  @if (!hidePeriodAndScope) {
    <div class="form-inline left-header">
      <span class="me-1 d-none d-md-block">{{ "theme.header.period" | translate }}</span>
      <app-year-range-input></app-year-range-input>
      <span class="ms-1 me-1 ms-md-3 me-md-3">|</span>
      <app-perimeters-filters-button></app-perimeters-filters-button>
    </div>
  }
  @if (perimeters?.length === 1 && !hidePeriodAndScope) {
    <div class="site-overview-button">
      <button nbButton ghost (click)="seeSiteOverview()">
        <i class="fa-thin fa-building"></i>
      </button>
    </div>
  }

  @if (!hidePeriodAndScope) {
    <app-perimeters-active-filters></app-perimeters-active-filters>
  }
</div>

<div class="header-container">
  <nb-actions size="medium">
    <nb-action>
      <app-language-selection></app-language-selection>
    </nb-action>

    <!-- INSIGHT / ASSET CARDS -->

    <!-- SCENARIO MANAGEMENT BUTTON -->
    @if (showScenariiMenu$ | async) {
      <nb-action
        nbTooltip="{{ 'Scenarii management' | translate }}"
        nbTooltipPlacement="bottom"
        nbTooltipStatus="primary"
        class="clickable"
      >
        <fa-icon icon="film" size="lg" (click)="openScenarii()"></fa-icon>
      </nb-action>
    }

    <!-- POWERPOINTS REPORTS MENU -->
    @if (perimeters && perimeters.length > sitesLimit && !reportLoading) {
      <nb-action (click)="tooMuchSitesSelected()">
        <div
          nbTooltip="{{ 'theme.header.powerpoint_reports' | translate }}"
          nbTooltipPlacement="bottom"
          nbTooltipStatus="primary"
        >
          <fa-icon icon="file-powerpoint" size="lg"></fa-icon>
        </div>
      </nb-action>
    }
    @if (perimeters && perimeters.length <= sitesLimit && !reportLoading && reportsMenu.length) {
      <nb-action [nbContextMenu]="reportsMenu" nbContextMenuTag="reportsMenu" nbContextMenuTrigger="hover">
        <fa-icon icon="file-powerpoint" size="lg"></fa-icon>
      </nb-action>
    }
    @if (reportsMenu.length && reportLoading) {
      <nb-action>
        <fa-icon icon="circle-notch" [spin]="true" size="lg" class="fa-spin"></fa-icon>
      </nb-action>
    }
    <!-- End report menu -->

    <!-- EXPORT MENU -->

      <nb-action
        class="export-icon"
        [nbContextMenu]="(exportMenu$ | async) || []"
        nbContextMenuTag="exportMenu"
        nbContextMenuTrigger="hover"
      >
        <div
          nbTooltipPlacement="bottom"
          nbTooltipStatus="primary"
          class="clickable"
        >
          @if (exportInProgress) {
            <fa-icon icon="circle-notch" [spin]="true" size="lg" class="fa-spin"></fa-icon>
          } @else {
            <fa-icon icon="file-excel" size="lg"></fa-icon>
          }
        </div>
      </nb-action>

        @if (canGoToAudit) {
          <nb-action (click)="goToAudit()">
            <div
              nbTooltip="{{ 'Open in GTP App' | translate }}"
              nbTooltipPlacement="bottom"
              nbTooltipStatus="primary"
              >
              <fa-icon icon="mobile-notch" class="fat" size="lg"></fa-icon>
            </div>
          </nb-action>
        }

        <nb-action
          [nbContextMenu]="userMenu">
          <fa-icon icon="user" size="lg"></fa-icon>&nbsp;&nbsp; <span class="header-menu-text">{{ user?.name }}</span>
        </nb-action>
      </nb-actions>
    </div>

    <!-- <ng-template #notificationsPopover>
    <div class="notifications-menu">
      <nb-list>
        <nb-list-item class="header">{{ 'theme.header.tasks' | translate:tasksStats }}</nb-list-item>
        <nb-list-item *ngFor="let task of tasks" class="task" (click)="openTask(task)">
          <div>{{ task.label }}</div>
          <div class="meta">
            <span [ngClass]="{'text-danger': !task.done && task.deadline_date < today}"><fa-icon icon="clock"></fa-icon> {{ task.deadline_date | date }}</span>
          </div>
        </nb-list-item>
      </nb-list>
    </div>
  </ng-template> -->
